import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NewsContentPageComponent } from '../component/page/news-content-page/news-content-page.component';
import { NewsPageComponent } from '../component/page/news-page/news-page.component';

const routes: Routes = [
  { path: 'news', component: NewsPageComponent },
  { path: 'news/:year/:pageTitle', component: NewsContentPageComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppNewsRoutingModule {}
